import { toggleModal } from '@/scripts/utils/index';
import { SELECTORS } from '../../scripts/constants';
import './memberContent.scss';


export function teamMember() {
  const memberTrigger = document.querySelectorAll('[data-member-trigger]');
  if (!memberTrigger.length) {
    return;
  }
  const memberContent = document.querySelector('[data-role="member-descr"]');
  const container = memberContent.querySelector('[data-content]');
  const closeButton = document.querySelector('[data-role="member-close"]');

  const toggleStatus = (bool) => {
    memberContent.classList.toggle(SELECTORS.active, bool);
    return toggleModal(bool, '[data-role="member-descr"]', memberContent);
  };

  const loadContent = (link) => {
    $.ajax({
      type: 'GET',
      url: link,
      success: (result) => {
        $(container).append(result);
      },
    });
  };

  const clearContent = () => {
    $(container).empty();
  };

  memberTrigger.forEach((element) => {
    element.addEventListener('click', (event) => {
      event.preventDefault();
      toggleStatus(true);
      loadContent(element.dataset.link);
    });
  });

  closeButton.addEventListener('click', (event) => {
    event.preventDefault();
    toggleStatus(false);
    setTimeout(clearContent, 100);
  });
}
